
// components/About.js
import React from 'react';
import SectionTitle from './SectionTitle';
import Button from './Button';
import Image from '../images/solar-energy.webp';
const About = () => {
  return (
    <section id="about" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src={Image}
              alt="About Kaat Engineering" 
              className="rounded-lg shadow-lg"
            />
          </div>
          <div>
            <SectionTitle 
              title="About Kaat Engineering" 
              subtitle="Your trusted partner in solar solutions"
            />
            
            <p className="text-gray-600 mb-6">
              Kaat Engineering is a leading provider of solar energy solutions, dedicated to helping
              homes and businesses transition to clean, renewable energy. Our team of experienced 
              professionals delivers custom-designed systems that maximize energy production and
              efficiency.
            </p>
            
            <p className="text-gray-600 mb-6">
              We pride ourselves on quality workmanship, exceptional customer service, and our
              commitment to creating a sustainable future. From initial consultation to installation
              and ongoing support, we're with you every step of the way.
            </p>
            
            <Button text="Learn More About Us" onClick={() => {}} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;